
// convert File to base64 string
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result?.toString() || "";
      const base64 = result.split(",")[1] || "";
      resolve(base64);
    };
    reader.onerror = error => reject(error);
  })
};
